export default __webpack_public_path__ + "static/media/ism2.197a19c2.jpeg";